const doc = [({"da":({"js":({"jobler":({"job_status":({"waiting":"Venter", "running":"Kører", "error":"Fejl", "view_details":"Se detaljer", "completed":"Færdig"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;